import { BOOKING_LIST_FILTER, CALENDAR_FILTER } from "../store/types";
import { createDropdownItem } from "./booking-artist.model";
import { getDefaultBPFilter } from "./status-colors";
import { getYearMonthH } from '../../../utility/calendar'

export function getSelectMonthDefaultDate() {
  const today = new Date();
  // if (today.getDate() > 15) {
  //   return addMonths(today, 1);
  // }
  return new Date();
}

export const initializeFilter = () => {
  return getDefaultFilter();
  
  // The following Code Persists the previous Filter State -- Commenting out for now - We dont need persistance right now
  
  // const localFilter = localStorage.getItem(BOOKING_LIST_FILTER);

  // const filter = localFilter ? JSON.parse(localFilter) : null;

  // if (filter && filter.selectedMonths && filter.selectedMonths.value && filter.bpFilter) {
  //   return filter;
  // } else {
  //   return getDefaultFilter();
  // }

};
export const getDefaultFilter = () => {
  return {
    selectedMonths: createDropdownItem(getSelectMonthDefaultDate()),
    selectedStatuses: [],
    selectedArtist: null,
    selectedStaff: null,
    bpFilter: getDefaultBPFilter(),
    txt:"",
    sort: {start_date: 'desc'}
  };
};

export const initializeCalendarFilter = () => {

  // const localFilter = sessionStorage.getItem(CALENDAR_FILTER.NAME);

  // const filter = localFilter ? JSON.parse(localFilter) : null;

  // if (filter && filter.selectedMonth) {
  //   return filter;
  // } else {
  //   return getDefaultCalendarFilter();
  // }

  return getDefaultCalendarFilter();

};

export const getDefaultCalendarFilter = () => {
  return {
    selectedMonth: getYearMonthH(new Date()),
    selectedStatuses: [],
    selectedArtists: [],
    selectedStaffs: [],
    showExternalCalendar: false,
  };
};

